var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.questions, function(item) {
      return _c("div", { key: item.name, staticClass: "my-4 border-bottom" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("div", [_vm._v(_vm._s(item.title))]),
            _c("custom-radio-button", {
              attrs: {
                "change-event": val => _vm.setAnswer(item, val),
                "question-lists": item
              }
            })
          ],
          1
        ),
        !_vm.isReadOnly
          ? _c(
              "div",
              [
                _c("validation-provider", {
                  attrs: {
                    name: item.title,
                    rules: _vm.isSubmitting ? "required" : "",
                    vid: `question-${item.name}`
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-input", {
                              attrs: {
                                "custom-error-msg": "Favor seleccionar Sí o No",
                                error: errors[0],
                                type: "hidden",
                                value: [false, true].includes(
                                  _vm.model[item.name]
                                )
                                  ? "1"
                                  : null
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "mx-3" }, [
          _vm.isSelected(item, "rubricRequired")
            ? _c("div", [
                _c("div", { staticClass: "mb-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-6" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            "custom-messages": {
                              min_value:
                                "La puntuación mínima debe ser mayor que 0.",
                              max_value:
                                "La puntuación mínima debe ser menor o igual que 100."
                            },
                            rules: "min_value:1|max_value:100"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "Puntuación Mínima:",
                                        placeholder: "0%",
                                        type: "number"
                                      },
                                      model: {
                                        value: _vm.model.minimumScore,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "minimumScore",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "model.minimumScore"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row my-4" }, [
                    _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column" },
                        [
                          _c("custom-drop-down", {
                            attrs: {
                              disabled: _vm.isReadOnly,
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Rúbrica:",
                              options: _vm.rubrics,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.rubric,
                              callback: function($$v) {
                                _vm.rubric = $$v
                              },
                              expression: "rubric"
                            }
                          }),
                          _c(
                            "action-button",
                            {
                              staticClass: "mt-3 align-end",
                              attrs: {
                                i: "fas fa-file-plus",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addRubric()
                                }
                              }
                            },
                            [_vm._v(" Añadir ")]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md border-left" },
                      [
                        _c("label", { staticClass: "data-name" }, [
                          _vm._v("Rúbrica(s) Seleccionado(s):")
                        ]),
                        _c("custom-chips-group", {
                          staticClass: "custom-chips-group",
                          attrs: {
                            disabled: _vm.isReadOnly,
                            "no-background": "",
                            "no-wrap": "",
                            "object-text": "name",
                            "on-item-deleted": _vm.removeRubric,
                            "selected-items": _vm.model.rubrics,
                            title: ""
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm.isSelected(item, "servicesRenewableRequired")
            ? _c("div", [
                _c("div", { staticClass: "mb-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _vm._m(0, true),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required|min_value:1" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido y debe ser mayor a 0",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        min: 0,
                                        type: "number"
                                      },
                                      model: {
                                        value:
                                          _vm.model.servicesRenewableDuration,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "servicesRenewableDuration",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression:
                                          "model.servicesRenewableDuration"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-3" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        clearable: false,
                                        "custom-error-msg":
                                          "El campo es requerido",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.durationTypes,
                                        placeholder: "Seleccione"
                                      },
                                      model: {
                                        value:
                                          _vm.servicesRenewableDurationType,
                                        callback: function($$v) {
                                          _vm.servicesRenewableDurationType = $$v
                                        },
                                        expression:
                                          "servicesRenewableDurationType"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "data-name" }, [
        _vm._v(" ¿Por cuánto tiempo? ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }